


export const InfoIconStroke = {
    data: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <circle cx="8" cy="8" r="7.5" stroke="#777777"/>
            <path d="M8.00008 11.7895C8.42113 11.7895 8.75798 11.3684 8.75798 10.9474V7.74738C8.75798 7.32633 8.42113 6.98948 8.00008 6.90527C7.57903 6.90527 7.24219 7.32633 7.24219 7.74738V10.9474C7.24219 11.3684 7.57903 11.7053 8.00008 11.7895Z" fill="#777777"/>
            <path d="M8.00008 5.39004C8.42113 5.39004 8.75798 4.96899 8.75798 4.54793C8.75798 4.12688 8.42113 3.79004 8.00008 3.79004C7.57903 3.79004 7.24219 4.21109 7.24219 4.54793C7.24219 4.96899 7.57903 5.39004 8.00008 5.39004Z" fill="#777777"/>
            </svg>
        `,
    name: 'info-stroke-icon' as const
};